const translations: Record<string, string> = {
  // ── Сторінка прогнозу (/forecast) ──
  fc_loading_data: 'Завантаження даних прогнозу…',
  fc_load_error_title: 'Помилка завантаження прогнозу',
  fc_demo_banner: 'Бекенд недоступний — показано демо-дані прогнозу',
  fc_footer_updated: 'Оновлено',
  fc_footer_model: 'Модель',
  fc_footer_refresh: 'Оновлення кожні 5 хв',
  fc_today: 'Сьогодні',
  fc_sum_title: 'Підсумок за добу',
  fc_map_reset: 'Повернути початковий вигляд карти',
  fc_sum_as_of: 'станом на {{hour}}',
  fc_sum_final: 'доба завершена',
  fc_sum_day_plan: 'Прогноз на повну добу',
  fc_sum_day_actual: 'Факт за добу',

  // Плитки KPI
  fc_kpi_total_energy: 'Прогнозована генерація',
  fc_kpi_max_hourly: 'Макс. погодинний прогноз (сьогодні)',
  fc_kpi_actual_pv: 'Фактична генерація',
  fc_current: 'поточний прогноз',

  // Основний графік
  fc_loading_hourly_cmp: 'Завантаження порівняння прогнозу…',
  fc_loading_30min_cmp: 'Завантаження 30-хв порівняння прогнозу…',
  fc_title_hourly: 'Погодинне порівняння прогнозу',
  fc_title_30min: '30-хвилинне порівняння прогнозу',
  fc_active_label: 'Активна',
  fc_active_title: 'Модель, яку система фактично використовує для цього активу (DAM/digest)',
  fc_mode_hourly: 'Погодинно',
  fc_mode_30min: '30 хвилин',
  fc_available_points: 'Доступні точки',
  fc_actual_points: 'Фактичні точки',
  fc_series_actual: 'Факт (PV)',
  fc_ecmwf_title: 'v0.2.2 модель на вхідних даних ECMWF IFS 0.25° замість Open-Meteo (ICON). Тестовий період 5-7 днів.',
  fc_empty_30min_title: '30-хвилинний прогноз недоступний',
  fc_empty_30min_body: 'Генератор 30-хв наразі не запланований. Перейдіть у погодинний режим, щоб побачити поточний прогноз v0.2.2.',
  fc_switch_hourly: 'Перейти на погодинний',

  // Підсумкові картки
  fc_sum_forecast_energy: 'Прогнозна енергія',
  fc_approx: 'прибл.',
  fc_sum_actual_energy: 'Фактична енергія',
  fc_sum_abs_error: 'Абс. похибка',
  fc_sum_rows_forecast: 'Рядків з прогнозом',
  fc_sum_rows_actual: 'Рядків з фактом',
  fc_interval: 'Інтервал',
  fc_30min_short: '30 хв',
  fc_sum_actual: 'Факт',
  fc_sum_base_abs_error: 'Абс. похибка (Base)',

  // Підписи тултіпів
  fc_tt_actual_pv_kw: 'Факт (PV), kW',
  fc_tt_actual_pv_kwh: 'Факт (PV), kWh',
  fc_tt_delta_vs_base_kw: 'Δ до Base, kW',
  fc_tt_delta_vs_base_pct: 'Δ до Base, %',
  fc_tt_calibration: 'Калібрування',
  fc_tt_calibration_mode: 'Режим калібрування',
  fc_tt_calibration_weight: 'Вага калібрування',
  fc_tt_bess_charge: 'Заряд BESS, kW',
  fc_tt_bess_discharge: 'Розряд BESS, kW',
  fc_tt_bess_power: 'Потужність BESS, kW',
  fc_tt_cloud_pct: 'Хмарність, %',
  fc_tt_cloud_lmh: 'Хмари Н/С/В',
  fc_tt_cloud_cover_pct: 'Хмарність, %',
  fc_tt_shortwave: 'Короткохвильова',
  fc_tt_direct: 'Пряма',
  fc_tt_shortwave_rad: 'Короткохвильова радіація',
  fc_tt_direct_rad: 'Пряма радіація',
  fc_tt_diffuse_rad: 'Розсіяна радіація',
  fc_tt_weather_interp: 'Інтерполяція погоди',
  fc_tt_temp_2m: 'Температура 2м',
  fc_tt_forecast_slot: 'Слот прогнозу',
  fc_tt_no_forecast_slot: 'Немає прогнозу для цього слоту',
  fc_tt_no_actual_yet: 'Ще немає фактичних даних',
  fc_tt_delta_kw: 'Дельта, kW',
  fc_tt_delta_pct: 'Дельта, %',
  fc_tt_abs_error_kw: 'Абс. похибка, kW',
  fc_tt_coverage: 'Покриття',
  fc_tt_quality_flag: 'Прапор якості',
  fc_tt_bess_quality_flag: 'Прапор якості BESS',
  fc_tt_delta_severity: 'Критичність відхилення',

  // Таблиця відхилень
  fc_loading_hourly: 'Завантаження погодинних даних…',
  fc_dev_title: 'Погодинне порівняння прогноз/факт',
  fc_dev_sum_forecast: 'прогноз',
  fc_dev_sum_actual: 'факт',
  fc_refresh_title: 'Оновити дані',
  fc_active_only: 'Активні год.',
  fc_all_hours: 'Усі год.',
  fc_col_hour: 'Година',
  fc_col_forecast_kwh: 'Прогноз, kWh',
  fc_col_actual_88: 'Факт 8/8',
  fc_col_shortwave: 'Короткохв.',
  fc_col_cloud: 'Хмари',
  fc_col_cloud_lmh: 'Хмари Н/С/В',
  fc_col_temp: 'Темп.',
  fc_col_sev: 'Крит.',
  fc_col_status: 'Статус',
  fc_sev_zero_ok: 'Нуль OK',
  fc_sev_f0: 'F=0',
  fc_sev_low: 'Низьке',
  fc_sev_high: 'Високе',
  fc_sev_critical: 'Критичне',
  fc_st_future: 'Майбутнє',
  fc_st_live: 'Наживо',
  fc_st_final: 'Фінал',
  fc_st_no_data: 'Немає даних',

  // Модальне вікно експорту
  fc_export_title: 'Експорт даних прогнозу',
  fc_date_from: 'Дата з',
  fc_date_to: 'Дата по',
  fc_coming_soon: 'Незабаром',
  fc_cancel: 'Скасувати',
  fc_download_xlsx: 'Завантажити XLSX',
  fc_preparing: 'Підготовка...',
  fc_preparing_export: 'Підготовка експорту...',
  fc_err_date_order: 'Дата "з" має бути раніше або дорівнювати даті "по"',
  fc_err_export_failed: 'Помилка експорту. Спробуйте ще раз.',
};

export default translations;
